<template>
    <section class="games-block container-mobile">
        <div class="games-block-body">
            <!-- <div class="games-block-puzzle"> -->
            <redirectButton pathname="puzzles" :html="$t('header.puzzleLogo')" class="games-block-puzzle"></redirectButton>
            <!-- </div> -->
            <!--            <div-->
            <!--                @click="showNext()"-->
            <!--                class="games-block-prev"-->
            <!--                :class="{disabled: !hasPrev}"-->
            <!--            ></div>-->
            <!--            <div-->
            <!--                ref="wrapper"-->
            <!--                class="games-block-wrapper"-->
            <!--                :class="{'overflowed': scrollWidth > clientWidth}"-->
            <!--            >-->
            <!--                <ul ref="list" class="games-block-list">-->
            <!--                    <li-->
            <!--                        v-for="game in 4"-->
            <!--                        v-if="game != 2"-->
            <!--                        ref="item"-->
            <!--                        class="games-block-item"-->
            <!--                        :class="'games-block-item-' + game"-->
            <!--                    >-->
            <!--                        <router-link-->
            <!--                            :to="{ name: 'game', params: {id: game}}"-->
            <!--                            class="games-block-link"-->
            <!--                        ></router-link>-->
            <!--                    </li>-->
            <!--                    <li-->
            <!--                        ref="item"-->
            <!--                        class="games-block-item"-->
            <!--                        :class="'games-block-item-puzzles'"-->
            <!--                    >-->
            <!--                        <router-link-->
            <!--                            :to="{ name: 'puzzles' }"-->
            <!--                            class="games-block-link"-->
            <!--                        ></router-link>-->
            <!--                    </li>-->
            <!--                </ul>-->
            <!--            </div>-->
            <!--            <div-->
            <!--                @click="showNext(true)"-->
            <!--                class="games-block-next"-->
            <!--                :class="{disabled: !hasNext}"-->
            <!--            ></div>-->
        </div>
    </section>
</template>

<script>
import redirectButton from '@/components/Buttons/Redirect';
// import {handleSwipe} from '@/mixins/handleSwipe';
// import {animate} from '@/mixins/animate';

export default {
    name: "Games",
    components: {
        redirectButton
    },
    props: {
        i18n: Object,
    },
    // mixins: [
    // animate,
    // handleSwipe
    // ],
    // data() {
    //     return {
    // hasPrev: false,
    // hasNext: false,
    // list: null,
    // slideWidth: 212,
    // margin: 18,
    // currentMargin: 0,
    // scrollWidth: 0,
    // clientWidth: 0
    // }
    // },
    // created() {
    //     setTimeout(() => {
    //         this.initCarousel();
    //     }, 200);
    //     window.addEventListener('resize', this.initCarousel);
    // },
    // beforeDestroy() {
    //     window.removeEventListener('resize', this.initCarousel);
    //     let self = this;
    //     this.handleSwipe(
    //         this.list,
    //         function(){ return self.showNext(true); },
    //         this.showNext,
    //         true
    //     );
    // },
    // methods: {
    //     initCarousel() {
    //         this.list = this.$refs.list;
    //         this.list.style.marginLeft = 0;
    //         this.slideWidth = window.innerWidth >= 480 ? 212 : 106;
    //         this.margin = window.innerWidth >= 480 ? 18 : 9;
    //
    //         this.currentMargin = 0;
    //         this.hasPrev = false;
    //         this.hasNext = false;
    //         this.scrollWidth = this.list.scrollWidth;
    //         this.clientWidth = this.list.clientWidth;
    //
    //         if (this.scrollWidth > this.clientWidth) {
    //
    //             this.hasNext = true;
    //             let self = this;
    //             this.handleSwipe(
    //                 this.list,
    //                 function(){ return self.showNext(true); },
    //                 function(){ return self.showNext(false); }
    //             );
    //
    //         } else {
    //             this.hasNext = false;
    //         }
    //     },
    //     checkPrevNext() {
    //         this.hasNext =
    //             this.scrollWidth >
    //             this.clientWidth +
    //             this.currentMargin ?
    //             true : false
    //
    //         this.hasPrev = this.currentMargin > 0 ? true : false;
    //
    //     },
    //     showNext(next=false) {
    //         let remainWidth, newMargin;
    //         if (next) {
    //             remainWidth =
    //                 this.scrollWidth -
    //                 this.clientWidth -
    //                 this.currentMargin;
    //
    //             newMargin =
    //                 remainWidth > this.slideWidth ?
    //                 this.currentMargin + this.slideWidth + this.margin :
    //                 this.scrollWidth - this.clientWidth;
    //
    //         } else {
    //             newMargin =
    //             this.currentMargin >
    //             this.slideWidth + this.margin ?
    //             this.currentMargin - this.slideWidth - this.margin :
    //             0
    //         }
    //         const testCallback = () => {
    //             this.currentMargin = newMargin;
    //             this.checkPrevNext();
    //         }
    //
    //         this.animate(
    //             this.list,
    //             'marginLeft',
    //             this.currentMargin * -1,
    //             newMargin * -1,
    //             200,
    //             testCallback
    //         );
    //     }
    // }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/layout/_games-block';
</style>
